import React from 'react';
import PropTypes from 'prop-types';

const types = {
  primary: 'bg-blue',
  secondary: 'bg-extra-light-gray',
  success: 'bg-green',
};

const Alert = ({ type, className, children }) => (
  <div className={className}>
    <div className={`${types[type]} text-center p-m`}>{children}</div>
  </div>
);

Alert.propTypes = {
  type: PropTypes.oneOf(Object.keys(types)),
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Alert.defaultProps = {
  type: 'secondary',
  className: '',
};

export default Alert;
